export default {
  computed: {
    triggered() {
      return [];
    },
    triggeredBy() {
      return [];
    },
  },
  methods: {
    hasDownstream() {
      return false;
    },
  },
};
